const PaymentHistory = {

    "payment_history": "Payment History",
    "invoice": "Invoice",
    "invoice_failed": "Invoice not available",
    "head_office": "Head Office",
    "branch_office": "Branch Office",
    "exam": "Exam",
    "payment_type": "Payment Type",
    "payment_status": "Payment Status",
    "reference_id": "Reference Id",
    "from_date": "From Date",
    "to_date": "To Date",

    "table_user": "USER",
    "table_head_branch": "HEAD BRANCH",
    "table_branch": "BRANCH",
    "table_exam": "EXAM",
    "table_payment_type": "PAYMENT TYPE",
    "table_payment_status": "PAYMENT STATUS",
    "table_reference_id": "REFERENCE ID",
    "table_total_amount": "TOTAL AMOUNT",
    "table_paid_amount": "PAID AMOUNT",
    "table_discount_amount": "DISCOUNT",
    "table_order_id": "ORDER ID",
    "table_date": "DATE",
    "coupon_code": "Coupon Code",
    "payment_id": "Payment Id",
    "failure_reason": "Failure Reason",
    "email": "Email",
    "phone": "Phone",
    "user_code": "User Code",
    "exam_code": "Exam Code",
    "seat_type": "Seat Type",
    "slot_type": "Slot Type",
    "student_seats": "Student Seats",
    "exam_date": "Exam Date",
    "start_time": "Start Time",
    "end_time": "End Time",
    "duration": "Duration",
    "total_marks": "Total Marks",
    "pass_percentage": "Pass Percentage",
    "currency": "Currency",
    "updated_at": "Updated At",
    "branch_type": "Branch Type",
    "address": "Address",
    "city": "City",
    "state": "State",
    "country": "Country",
    "pincode": "Pincode",
    "authorize_person": "Authorize Person",
    "branch_status": "Branch Status",
    "user_status": "User Status",
    "exam_status": "Exam Status",
    "current_exam_status": "Exam Progress",
    "section_payment": "Payment",
    "section_user": "User",
    "section_branch": "Branch",
    "section_exam": "Exam",

}

export default PaymentHistory;
